/**
 * FAQCategoryButton Component
 */

import './faq-category-button.scss';

import { Link } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import { IconList } from '../../atoms/images/Icon';
import Heading from '../../atoms/text/Heading';
import { Span } from '../../atoms/text/Label';
import { FAQPageSectionPath } from './';

interface IOwnProps {
  id: string;
  title: string;
  totalQuestions: number;
  onSelect(): void;
}

const classes = new BEM({ name: 'faq-category-button', outputIsString: true });

export default function FAQCategoryButton(props: IOwnProps) {
  return (
    <Link
      to={FAQPageSectionPath(props.id)}
      activeClassName={classes('', 'active')}
      className={classes()}
      onClick={props.onSelect}
    >
      <IconList className={classes('icon')} />
      <div className={classes('info')}>
        <Heading
          is="h5"
          text={props.title}
          maxTextLength={25}
          noMargin
          className={classes('title')}
        />
        <Span variant="note" size="medium" className={classes('subtitle')}>{props.totalQuestions} questions</Span>
      </div>
    </Link>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/FAQ/FAQCategoryButton.tsx